import * as React from 'react';
import { SVGProps } from 'react';

const FileIconJpgSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 14H6v6.667L9 18l6.5 6H18V14H6.5ZM6 23.5v-1.167l3-2.81L14 24H6v-.5Zm-1-9V25h14V13H5v1.5Zm8 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3V2H7v1h1ZM6.9 9.91a.338.338 0 0 1-.25.09H5.5v1h1.46c.307 0 .557-.1.75-.3.193-.193.29-.46.29-.8V4H6v1h1v4.7a.256.256 0 0 1-.1.21Zm2.9-5.67V4H9v7h1.01V9h1.29c.58 0 1.007-.127 1.28-.38.28-.253.42-.66.42-1.22V5.6c0-.567-.137-.973-.41-1.22-.273-.253-.703-.38-1.29-.38h-.7c-.327 0-.593.08-.8.24Zm.36.94c.107-.12.27-.18.49-.18h.6c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17h-1.24L10 5.55a.53.53 0 0 1 .16-.37ZM16.25 9c.293 0 .543-.067.75-.2V9c0 1 0 1-1 1h-1.5v1H17a1 1 0 0 0 1-1V4h-2.3c-.58 0-1.01.127-1.29.38-.273.253-.41.66-.41 1.22v1.8c0 .567.137.977.41 1.23.273.247.703.37 1.29.37h.55Zm.59-1.17c-.107.113-.27.17-.49.17h-.6c-.247 0-.433-.057-.56-.17-.127-.113-.19-.273-.19-.48v-1.7c0-.207.063-.367.19-.48.127-.113.313-.17.56-.17H17v2.45c0 .133-.053.26-.16.38Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconJpgSizeS;
